<div style="display: flex; justify-content: center;">
    <div id="selectedLayout" [innerHtml]="selectedLayout | safeHtml"></div>
</div>
